import { Slot, Slottable } from '@radix-ui/react-slot';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import React from 'react';
import styles from './Pill.module.scss';

const cvaPill = cva(styles.pillContainer, {
  variants: {
    variant: {
      subtle: styles['variant-subtle'],
      normal: styles['variant-normal'],
      success: styles['variant-success'],
      alert: styles['variant-alert'],
      danger: styles['variant-danger'],
    },
    size: {
      xsmall: styles['size-xsmall'],
      small: styles['size-small'],
      medium: styles['size-medium'],
    },
  },
  defaultVariants: { variant: 'subtle', size: 'medium' },
});

type Props = React.HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof cvaPill> & {
    asChild?: boolean;
    /** Prepend a react node with slight margin offset (as per icons in design) */
    pre?: React.ReactNode;
    /** Postfix a react node with slight margin offset (as per icons in design) */
    post?: React.ReactNode;
  };

export const Pill = React.forwardRef<HTMLSpanElement, Props>((props, ref) => {
  const { asChild, className, pre, post, variant, size, ...rest } = props;
  const Component = asChild ? Slot : 'span';
  return (
    <Component ref={ref} {...rest} className={cvaPill({ variant, size, className })}>
      {!!pre && <span className={styles.prefix}>{pre}</span>}
      <Slottable>{props.children}</Slottable>
      {!!post && <span className={styles.postfix}>{post}</span>}
    </Component>
  );
});
